import { Popover, PopoverTrigger } from '@chakra-ui/react';
import { FC, PropsWithChildren, useRef } from 'react';
import { DeleteConfirmationPopoverContent } from '../DeleteConfirmation';

type DeletePopoverProps = PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}>;

const DeletePopover: FC<DeletePopoverProps> = ({ isOpen, onClose, onDelete, children }) => {
  const initialFocusRef = useRef<HTMLButtonElement>(null);
  return (
    <Popover
      isOpen={isOpen}
      onClose={onClose}
      placement="right"
      isLazy
      autoFocus
      returnFocusOnClose
      initialFocusRef={initialFocusRef}
    >
      <PopoverTrigger>{children}</PopoverTrigger>
      <DeleteConfirmationPopoverContent
        initialFocusRef={initialFocusRef}
        onClose={onClose}
        confirmationText="Are you sure you want to delete this element?"
        onConfirm={onDelete}
      />
    </Popover>
  );
};

export default DeletePopover;
